import { Component, OnInit } from '@angular/core';
import { ConferenceViewModelSimple } from 'src/app/_models/generatedModels';
import { UserService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-my-conference-expenses',
  templateUrl: 'my-conference-expenses.component.html',
})
export class MyConferenceExpensesComponent implements OnInit {
  initialized = false;
  conferences: ConferenceViewModelSimple[];
  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService.getConferencesWithExpenses().subscribe((data) => {
      this.conferences = data;
      this.initialized = true;
    });
  }
}
